/*
Copyright (c) 2021
*/

import constants from '../../constants';

const { REQUEST_RECRUITS_SCREENER_DATA, RECRUITS_SCREENER_DATA_RECEIVED } = constants.RecruitScreener;

export default {
    REQUEST_RECRUITS_SCREENER_DATA,
    RECRUITS_SCREENER_DATA_RECEIVED,

  requestRecruitScreener: payload => ({
    type: REQUEST_RECRUITS_SCREENER_DATA,
    payload
  }),
  requestRecruitScreenerReceived: () => ({
    type: RECRUITS_SCREENER_DATA_RECEIVED
  }),
};
